var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c(_vm.injections.components.LoadingSign,{tag:"component",attrs:{"loadingmessage1":_vm.props.loadingMessage1,"loadingmessage2":_vm.props.loadingMessage2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }